<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" :offset="6">
        <div style="font-size:20px;margin-bottom:20px">Ticket Summary</div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :offset=6 :span="2">
        <el-input
          placeholder="Start MMDD"
          size="small"
          prefix-icon="el-icon-search"
          v-model="filters.startDate"
        />
      </el-col>
      <el-col :span="2">
        <el-input
          placeholder="End MMDD"
          size="small"
          prefix-icon="el-icon-search"
          v-model="filters.endDate"
        />
      </el-col>
      <el-col :span="1">
        <div
          @click="refreshData()"
          v-shortkey="['enter']"
          @shortkey="refreshData()"
          style="cursor:pointer;"
        >
          <i class="el-icon-refresh" style="color:#409EFF;font-size:24px"/>
        </div>
      </el-col>
    </el-row>
        <el-row>
      <el-col :offset="6" :span="16">
        <el-divider content-position="left"></el-divider>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="1" :offset="6">
        <div style="font-size:20px">Count:</div>
      </el-col>
      <el-col :span="1" >
        <div style="font-size:20px; text-align:right;">{{data.summaryData.numTickets}}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="1" :offset="6">
        <div style="font-size:20px">Amount:</div>
      </el-col>
      <el-col :span="1" >
        <div style="font-size:20px; text-align:right;">{{data.summaryData.amount}}</div>
      </el-col>
      <el-col :span="1" >
        <div style="font-size:20px; text-align:left;margin-left:10px;">RON</div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import axios from "axios";
import { Promise } from "q";

export default {
  name: "Summary",
  data() {
    return {
      data: {
        summaryData: {
          numTickets: 0,
          amount: 0
        }
      },
      filters: {
        startDate: null,
        endDate: null
      }
    };
  },
  methods: {
    refreshData() {
      //compute full (YYYYNNDD) dates; if provided startDate>toDayMD => startDate is for previous year
      var toDay = new Date();
      var toDayYear = toDay.getFullYear();
      var toDayMD = (toDay.getMonth() + 1) * 100 + toDay.getDate();
      var startDate = 20010101;
      if (this.filters.startDate) {
        startDate = Number(this.filters.startDate);
        if (toDayMD < startDate) {
          startDate += (toDayYear - 1) * 10000;
        } else {
          startDate += toDayYear * 10000;
        }
      }
      var endDate = 29990101;
      if (this.filters.endDate) {
        endDate = Number(this.filters.endDate) + toDayYear * 10000;
      }
      var url = `${
        process.env.VUE_APP_API
      }tickets/summary?startDate=${startDate}&endDate=${endDate}`;

      axios
        .get(url, {
          headers: {
            Authorization: window.sessionStorage.getItem("token")
          }
        })
        .then(result => {
          this.data = result.data;
        });
    }
  }
};
</script>